import slug from "slug";

export const toUrlSlug = (value = "") => {
    return slug(String(value), {
        mode: "rfc3986",
        lower: true,
        trim: true,
        remove: /[.]/g,
    });
};
